var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgScreenLayer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.1819 0.636353H0.636475V10.1818H10.1819V0.636353ZM8.81829 1.99999H2.00011V8.81817H8.81829V1.99999Z",
    fill: "#414042"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.091 0.636353H11.5456V10.1818H21.091V0.636353ZM19.7274 1.99999H12.9092V8.81817H19.7274V1.99999Z",
    fill: "#414042"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.0001 0.636353H22.4547V10.1818H32.0001V0.636353ZM30.6365 1.99999H23.8183V8.81817H30.6365V1.99999Z",
    fill: "#414042"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.1819 11.5454H0.636475V21.0909H10.1819V11.5454ZM8.81829 12.9091H2.00011V19.7273H8.81829V12.9091Z",
    fill: "#414042"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.091 11.5454H11.5456V21.0909H21.091V11.5454ZM19.7274 12.9091H12.9092V19.7273H19.7274V12.9091Z",
    fill: "#414042"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.0001 11.5454H22.4547V21.0909H32.0001V11.5454ZM30.6365 12.9091H23.8183V19.7273H30.6365V12.9091Z",
    fill: "#414042"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.1819 22.4545H0.636475V32H10.1819V22.4545ZM8.81829 23.8182H2.00011V30.6364H8.81829V23.8182Z",
    fill: "#414042"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.091 22.4545H11.5456V32H21.091V22.4545ZM19.7274 23.8182H12.9092V30.6364H19.7274V23.8182Z",
    fill: "#414042"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.0001 22.4545H22.4547V32H32.0001V22.4545ZM30.6365 23.8182H23.8183V30.6364H30.6365V23.8182Z",
    fill: "#414042"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.00012 3.36365H8.8183V8.81819H2.00012V3.36365Z",
    fill: "#414042"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.9092 7.45456H19.7274V8.81819H12.9092V7.45456Z",
    fill: "#414042"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.00012 17H8.8183V19.7273H2.00012V17Z",
    fill: "#414042"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.9092 15.6364H19.7274V19.7273H12.9092V15.6364Z",
    fill: "#414042"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.8183 23.8182H30.6365V30.6364H23.8183V23.8182Z",
    fill: "#414042"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.9092 25.1818H19.7274V30.6364H12.9092V25.1818Z",
    fill: "#414042"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.00012 29.2727H8.8183V30.6364H2.00012V29.2727Z",
    fill: "#414042"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 31.3636,
    height: 31.3636,
    fill: "white",
    transform: "translate(0.636475 0.636353)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScreenLayer);
export default __webpack_public_path__ + "static/media/ScreenLayer.08961760190f843f1e223bcca01c4ea6.svg";
export { ForwardRef as ReactComponent };